schoolwork12.app.manageCourseManagement = {
  name: "schoolwork12.courseManagement",
  routes: {
    courseManagement: {
      route: "/course-management",
      templateUrl: "ng-migration/course-management/components/course-management.component.html",
      displayName: 'Course Management',
    },
    addCourse: {
      route: "/add-course",
      template: "<app-course-management-add></app-course-management-add>",
      displayName: "Add New Course"
    },
    editCourse: {
      route: "/edit-course/:code",
      template: "<app-course-management-edit></app-course-management-edit>",
      displayName: "Edit Course"
    }
  },
  endpoints: {
    addCourse: "/course/savecourseDetails",
    editCourse: "/course/savecourseDetails",
    courseFilter: "/course/getFindCoursesDataForm/",
    courseDropDownDetails: "/course/courseDropDownDetails/",
    courseByCode: "/course/courseCode/",
    nextCourseListByCode: "/course/nextCourseListByCode/",
    reactivateCourses: "/course/reactivateCourses/",
    deactivateCourses: "/course/deactivateCourses/",
    searchCourses: "/course/coursesByCriteria/",
  },
  errorMessages: {
    invalidCreateDateFrom:
      "Invalid Create Date (From). Enter in MM/DD/YYYY format",
    invalidCreateDateTo:
      "Invalid Create Date (To). Enter in MM/DD/YYYY format.",
    courseCodeRequired: "Course Code is required.",
    courseNameRequired: "Course Name is required.",
    defaultCreditsRequired: "Default Credits is required.",
    courseGradeRequired: "Course Grade is required.",
    courseTypeRequired: "Course Type is required.",
    daysPerWeekRequired: "Days per Week is required for this course.",
    defaultAttendanceRequired:
      "Default Attendance Minutes is required for this course.",
    maxNumberPrepDaysRequired:
      "Max Number of Prep Days is required for this course.",
    coursePlatformRequired: "Platform is required for this course.",
    contentProviderRequired: "Content Provider is required for this course.",
    courseNameMaxLength: "Course Name must not exceed 50 characters in length.",
    abbreviationMaxLength:
      "Abbreviation must not exceed 20 characters in length.",
    daysPerWeekInvalidRange:
      "Days per Week must be a number within the range of 1 to 7.",
    nextCourseInvalidValue:
      "Next Course(s) must contain only valid course codes.",
    defaultAttendanceInvalidRange:
      "Default Attendance Minutes must be a number within the range of 1 to 120.",
    maxNumberPrepInvalidValue:
      "Max Number of Prep Days must be a number within the range of 0 to 21.",
    courseCodeDuplicated:
      "Course Code is already in use by another course. Please enter a unique Course Code.",
    courseNameDuplicated:
      "Course Name is already in use by another course. Please enter a unique Course Name.",
  },
};
